<template>
    <div
        class="Logo">
        <img :src="logo" alt="Hempel Yacht" @click="$router.push('/')">
        <!--
        <svg
            @click="$router.push('/')"
            width="200"
            height="56"
            viewBox="0 0 200 50"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <defs>
                <linearGradient
                    x1="98.8177317%"
                    y1="61.6707211%"
                    x2="1.50253271%"
                    y2="37.9230056%"
                    id="linearGradient-1">
                    <stop
                        stop-color="#009FDF"
                        offset="26%"/>
                    <stop
                        stop-color="#66C5EC"
                        offset="100%"/>
                </linearGradient>
                <linearGradient
                    x1="-15.4465492%"
                    y1="5.76326245%"
                    x2="73.5480242%"
                    y2="61.3173054%"
                    id="linearGradient-2">
                    <stop
                        stop-color="#009FDF"
                        offset="0%"/>
                    <stop
                        stop-color="#009FDF"
                        stop-opacity="0.5"
                        offset="100%"/>
                </linearGradient>
                <linearGradient
                    x1="60.5898565%"
                    y1="99.6415663%"
                    x2="40.1397523%"
                    y2="0.797730666%"
                    id="linearGradient-3">
                    <stop
                        stop-color="#009FDF"
                        offset="0%"/>
                    <stop
                        stop-color="#66C5EC"
                        offset="100%"/>
                </linearGradient>
                <linearGradient
                    x1="38.8243687%"
                    y1="49.9959235%"
                    x2="-0.226081554%"
                    y2="49.9959235%"
                    id="linearGradient-4">
                    <stop
                        stop-color="#009FDF"
                        stop-opacity="0.5"
                        offset="0%"/>
                    <stop
                        stop-color="#0076C7"
                        stop-opacity="0.69"
                        offset="44%"/>
                    <stop
                        stop-color="#0033A0"
                        offset="100%"/>
                </linearGradient>
                <linearGradient
                    x1="2.50115685%"
                    y1="32.3404123%"
                    x2="97.00863%"
                    y2="66.7181953%"
                    id="linearGradient-5">
                    <stop
                        stop-color="#FFFFFF"
                        offset="35%"/>
                    <stop
                        stop-color="#FBFBFD"
                        offset="42%"/>
                    <stop
                        stop-color="#EDF1F8"
                        offset="50%"/>
                    <stop
                        stop-color="#D7DFF0"
                        offset="59%"/>
                    <stop
                        stop-color="#B8C6E5"
                        offset="67%"/>
                    <stop
                        stop-color="#91A7D6"
                        offset="76%"/>
                    <stop
                        stop-color="#6080C4"
                        offset="85%"/>
                    <stop
                        stop-color="#2853AF"
                        offset="94%"/>
                    <stop
                        stop-color="#0033A0"
                        offset="100%"/>
                </linearGradient>
                <linearGradient
                    x1="-15.4465492%"
                    y1="5.76326245%"
                    x2="73.5480242%"
                    y2="61.3173054%"
                    id="linearGradient-6">
                    <stop
                        stop-color="#B2C2E2"
                        offset="40%"/>
                    <stop
                        stop-color="#ACBDE0"
                        offset="47%"/>
                    <stop
                        stop-color="#9BB0DA"
                        offset="56%"/>
                    <stop
                        stop-color="#7F99CF"
                        offset="67%"/>
                    <stop
                        stop-color="#587AC1"
                        offset="79%"/>
                    <stop
                        stop-color="#2753AF"
                        offset="91%"/>
                    <stop
                        stop-color="#0033A0"
                        offset="100%"/>
                </linearGradient>
                <linearGradient
                    x1="86.7043063%"
                    y1="14.1495695%"
                    x2="37.4251235%"
                    y2="85.7769951%"
                    id="linearGradient-7">
                    <stop
                        stop-color="#FFFFFF"
                        offset="0%"/>
                    <stop
                        stop-color="#7C96CE"
                        offset="52%"/>
                    <stop
                        stop-color="#0033A0"
                        offset="100%"/>
                </linearGradient>
                <linearGradient
                    x1="49.9690223%"
                    y1="0.43028206%"
                    x2="49.9690223%"
                    y2="77.3432003%"
                    id="linearGradient-8">
                    <stop
                        stop-color="#0033A0"
                        offset="0%"/>
                    <stop
                        stop-color="#0839A3"
                        offset="9%"/>
                    <stop
                        stop-color="#1D4AAB"
                        offset="22%"/>
                    <stop
                        stop-color="#3F65B7"
                        offset="38%"/>
                    <stop
                        stop-color="#6F8CC9"
                        offset="56%"/>
                    <stop
                        stop-color="#ACBDE0"
                        offset="76%"/>
                    <stop
                        stop-color="#F6F7FB"
                        offset="97%"/>
                    <stop
                        stop-color="#FFFFFF"
                        offset="100%"/>
                </linearGradient>
            </defs>
            <g
                id="🖥-desktop-"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd">
                <g
                    id="welcome"
                    transform="translate(-1002.000000, -34.000000)"
                    fill-rule="nonzero">
                    <g
                        id="hempel-logo"
                        transform="translate(1002.000000, 34.000000)">
                        <polygon
                            id="Shape"
                            fill="#0033A0"
                            points="199.619718 32.1340845 199.619718 37.7002817 181.697183 37.7002817 181.697183 13.0448826 188.147887 13.0448826 188.169014 32.1340845"/>
                        <polygon
                            id="Shape"
                            fill="#0033A0"
                            points="178.161972 32.1340845 178.161972 37.7002817 159.225352 37.7002817 159.225352 13.0448826 178.161972 13.0448826 178.161972 18.6039437 165.676056 18.6039437 165.676056 22.5430986 174.93662 22.5430986 174.93662 28.1092958 165.697183 28.1092958 165.697183 32.1340845"/>
                        <path
                            d="M157.15493,21.4512676 C157.135844,25.5477865 154.200825,29.0317069 150.211268,29.6935211 C149.47776,29.811274 148.735497,29.8638058 147.992958,29.8505164 L142.711268,29.8505164 L142.711268,37.7002817 L136.197183,37.7002817 L136.197183,13.0448826 L147.992958,13.0448826 C148.735797,13.0305362 149.478363,13.0854783 150.211268,13.2090141 C154.199731,13.8676441 157.135318,17.3492227 157.15493,21.4441315 L157.15493,21.4512676 Z M150.992958,21.4512676 C150.992958,19.8747928 149.731788,18.5968075 148.176056,18.5968075 L142.690141,18.5968075 L142.690141,24.2629108 L148.190141,24.2629108 C149.726736,24.2552467 150.973769,23.0011118 150.992958,21.4441315 L150.992958,21.4512676 Z"
                            id="Shape"
                            fill="#0033A0"/>
                        <path
                            d="M115.767606,14.5077934 L119.014085,28.1092958 L122.746479,14.4435681 C122.972297,13.5906876 123.741357,13.0025264 124.612676,13.016338 L132.570423,13.0160998 L132.570423,37.7002817 L126.014085,37.7002817 L126.014085,20.6948357 L121.478873,37.7359624 L115.84507,37.7359624 L111.373239,20.6948357 L111.373239,37.7002817 L105.309859,37.7002817 L105.309859,13.0448826 L113.880282,13.0448826 C114.768777,13.0277781 115.551341,13.6343623 115.767606,14.5077934 Z"
                            id="Shape"
                            fill="#0033A0"/>
                        <polygon
                            id="Shape"
                            fill="#0033A0"
                            points="101.669014 32.1340845 101.669014 37.7002817 82.7323944 37.7002817 82.7323944 13.0448826 101.669014 13.0448826 101.669014 18.6039437 89.1830986 18.6039437 89.1830986 22.5430986 98.443662 22.5430986 98.443662 28.1092958 89.2042254 28.1092958 89.2042254 32.1340845"/>
                        <polygon
                            id="Shape"
                            fill="#0033A0"
                            points="63.1760563 13.0448826 63.1760563 22.5430986 72.4366197 22.5430986 72.4366197 13.0448826 79.0985915 13.0448826 79.0985915 37.7002817 72.4366197 37.7002817 72.4366197 28.1092958 63.1760563 28.1092958 63.1760563 37.7002817 56.7253521 37.7002817 56.7253521 13.0448826"/>
                        <path
                            d="M42.7605634,9.70516432 C39.4609787,5.73446397 35.0352536,2.88914891 30.084507,1.55568075 C20.8732394,-0.90629108 10.6690141,2.09089202 4.79577465,9.67661972 C1.97674993,13.3139473 0.316391566,17.7342339 0.0352112676,22.3504225 C-0.288643967,29.0322736 2.32642308,35.5159893 7.17605634,40.0552113 C9.09000857,43.1863955 11.8028754,45.735728 15.028169,47.4339906 C20.6040743,50.3699416 27.1238614,50.8615855 33.067189,48.7942763 C39.0105166,46.7269671 43.8578601,42.2814147 46.4788732,36.4942723 C50.4788732,27.7596244 48.8521127,17.1267606 42.7605634,9.70516432 Z M36.8873239,40.6760563 C33.4107605,44.4887987 28.5207246,46.6569087 23.3978873,46.6569087 C18.2750501,46.6569087 13.3850141,44.4887987 9.9084507,40.6760563 C5.88732394,36.4514554 1.66901408,27.45277 6.05633803,17.8403756 C9.15492958,11.1181221 16.0633803,6.95061033 24,7.40018779 C24.5780113,7.43422274 25.1538981,7.49853402 25.7253521,7.59286385 C31.0321974,8.39869894 35.7448148,11.4679073 38.6724445,16.0249772 C41.6000743,20.5820472 42.462662,26.1910536 41.0422535,31.4347418 C40.7095225,34.8975549 39.2475362,38.1492767 36.8873239,40.6760563 Z"
                            id="Shape"
                            fill="url(#linearGradient-1)"/>
                        <path
                            d="M18.2394405,17.2266667 C21.1585685,14.9884402 24.8263851,13.9971445 28.457757,14.4649765 C33.0409569,15.1411849 37.0347539,17.9831216 39.2183273,22.1220657 C40.4747854,24.4731719 41.1308518,27.1054408 41.1267981,29.7791549 C41.1267792,24.1130516 38.8450876,18.1044131 34.0070563,14.9074178 C29.0774757,11.6319249 22.3098657,12.1528638 17.6619753,15.8279812 C14.9645328,17.9007934 13.058464,20.856011 12.2676056,24.1915493 C12.8489251,22.6993147 13.677771,21.3187948 14.7183114,20.1096714 C15.7236106,18.9547865 16.9140355,17.9800989 18.2394405,17.2266667 Z"
                            id="Shape"
                            fill="url(#linearGradient-2)"/>
                        <path
                            d="M5.07042254,26.7391549 C5.72405933,31.4856349 7.90194388,35.8819259 11.2676056,39.2488263 C14.39582,42.673911 18.7924291,44.6210789 23.3978873,44.6210789 C28.0033456,44.6210789 32.3999546,42.673911 35.528169,39.2488263 C40.4155012,33.915228 40.4155012,25.6644903 35.528169,20.330892 C34.7261181,19.4701518 33.8087001,18.7278729 32.8028169,18.1258216 C38.4378335,22.3140211 39.9795011,30.1717631 36.3539508,36.2256342 C32.7284005,42.2795053 25.138178,44.5215189 18.8703525,41.389971 C12.602527,38.258423 9.73605083,30.7920054 12.2676056,24.1915493 C14.0300249,16.8505777 20.9094675,11.9869718 28.3169014,12.8450704 C24.8608836,10.9974725 20.8198329,10.6249725 17.0915493,11.8103286 C10.9975515,13.8426403 6.38876688,18.9455549 4.92957746,25.2762441 C4.97887324,25.7686385 5.01408451,26.2610329 5.07042254,26.7391549 Z"
                            id="Shape"
                            fill="url(#linearGradient-3)"/>
                        <path
                            d="M5.07042254,26.7391549 C5.72405933,31.4856349 7.90194388,35.8819259 11.2676056,39.2488263 C14.39582,42.673911 18.7924291,44.6210789 23.3978873,44.6210789 C28.0033456,44.6210789 32.3999546,42.673911 35.528169,39.2488263 C40.4155012,33.915228 40.4155012,25.6644903 35.528169,20.330892 C34.7261181,19.4701518 33.8087001,18.7278729 32.8028169,18.1258216 C38.4378335,22.3140211 39.9795011,30.1717631 36.3539508,36.2256342 C32.7284005,42.2795053 25.138178,44.5215189 18.8703525,41.389971 C12.602527,38.258423 9.73605083,30.7920054 12.2676056,24.1915493 C14.0300249,16.8505777 20.9094675,11.9869718 28.3169014,12.8450704 C24.8608836,10.9974725 20.8198329,10.6249725 17.0915493,11.8103286 C10.9975515,13.8426403 6.38876688,18.9455549 4.92957746,25.2762441 C4.97887324,25.7686385 5.01408451,26.2610329 5.07042254,26.7391549 Z"
                            id="Shape"
                            fill="url(#linearGradient-4)"
                            style="mix-blend-mode: multiply;"/>
                        <path
                            d="M42.7605634,9.70516432 C39.4609787,5.73446397 35.0352536,2.88914891 30.084507,1.55568075 C20.8732394,-0.90629108 10.6690141,2.09089202 4.79577465,9.67661972 C1.97674993,13.3139473 0.316391566,17.7342339 0.0352112676,22.3504225 C-0.288643967,29.0322736 2.32642308,35.5159893 7.17605634,40.0552113 C9.09000857,43.1863955 11.8028754,45.735728 15.028169,47.4339906 C20.6040743,50.3699416 27.1238614,50.8615855 33.067189,48.7942763 C39.0105166,46.7269671 43.8578601,42.2814147 46.4788732,36.4942723 C50.4788732,27.7596244 48.8521127,17.1267606 42.7605634,9.70516432 Z M36.8873239,40.6760563 C33.4107605,44.4887987 28.5207246,46.6569087 23.3978873,46.6569087 C18.2750501,46.6569087 13.3850141,44.4887987 9.9084507,40.6760563 C5.88732394,36.4514554 1.66901408,27.45277 6.05633803,17.8403756 C9.15492958,11.1181221 16.0633803,6.95061033 24,7.40018779 C24.5780113,7.43422274 25.1538981,7.49853402 25.7253521,7.59286385 C31.0321974,8.39869894 35.7448148,11.4679073 38.6724445,16.0249772 C41.6000743,20.5820472 42.462662,26.1910536 41.0422535,31.4347418 C40.7095225,34.8975549 39.2475362,38.1492767 36.8873239,40.6760563 Z"
                            id="Shape"
                            fill="url(#linearGradient-5)"
                            opacity="0.5"
                            style="mix-blend-mode: multiply;"/>
                        <path
                            d="M18.2394405,17.2266667 C21.1585685,14.9884402 24.8263851,13.9971445 28.457757,14.4649765 C33.0409569,15.1411849 37.0347539,17.9831216 39.2183273,22.1220657 C40.4747854,24.4731719 41.1308518,27.1054408 41.1267981,29.7791549 C41.1267792,24.1130516 38.8450876,18.1044131 34.0070563,14.9074178 C29.0774757,11.6319249 22.3098657,12.1528638 17.6619753,15.8279812 C14.9645328,17.9007934 13.058464,20.856011 12.2676056,24.1915493 C12.8489251,22.6993147 13.677771,21.3187948 14.7183114,20.1096714 C15.7236106,18.9547865 16.9140355,17.9800989 18.2394405,17.2266667 Z"
                            id="Shape"
                            fill="url(#linearGradient-6)"
                            style="mix-blend-mode: multiply;"/>
                        <path
                            d="M42.7605634,9.70516432 C39.4609787,5.73446397 35.0352536,2.88914891 30.084507,1.55568075 C20.8732394,-0.90629108 10.6690141,2.09089202 4.79577465,9.67661972 C1.97674993,13.3139473 0.316391566,17.7342339 0.0352112676,22.3504225 C-0.288643967,29.0322736 2.32642308,35.5159893 7.17605634,40.0552113 C9.09000857,43.1863955 11.8028754,45.735728 15.028169,47.4339906 C20.6040743,50.3699416 27.1238614,50.8615855 33.067189,48.7942763 C39.0105166,46.7269671 43.8578601,42.2814147 46.4788732,36.4942723 C50.4788732,27.7596244 48.8521127,17.1267606 42.7605634,9.70516432 Z M36.8873239,40.6760563 C33.4107605,44.4887987 28.5207246,46.6569087 23.3978873,46.6569087 C18.2750501,46.6569087 13.3850141,44.4887987 9.9084507,40.6760563 C5.88732394,36.4514554 1.66901408,27.45277 6.05633803,17.8403756 C9.15492958,11.1181221 16.0633803,6.95061033 24,7.40018779 C24.5780113,7.43422274 25.1538981,7.49853402 25.7253521,7.59286385 C31.0321974,8.39869894 35.7448148,11.4679073 38.6724445,16.0249772 C41.6000743,20.5820472 42.462662,26.1910536 41.0422535,31.4347418 C40.7095225,34.8975549 39.2475362,38.1492767 36.8873239,40.6760563 Z"
                            id="Shape"
                            fill="url(#linearGradient-5)"
                            opacity="0.5"
                            style="mix-blend-mode: multiply;"/>
                        <path
                            d="M9.9084507,40.6760563 C5.91549296,36.48 1.73943662,27.5883568 5.95774648,18.0758685 C5.95774648,18.004507 6.02112676,17.9331455 6.05633803,17.8546479 C9.15492958,11.1181221 16.0633803,6.95061033 24,7.40018779 L23.6549296,0.713615023 C16.3463923,0.620176853 9.39786929,3.92253291 4.79577465,9.67661972 C1.97674993,13.3139473 0.316391566,17.7342339 0.0352112676,22.3504225 C-0.00345721247,23.1015864 -0.00345721247,23.8542822 0.0352112676,24.605446 C0.333698634,30.5025711 2.89655062,36.0474977 7.17605634,40.0552113 C11.3882433,44.2593051 17.0526424,46.6325923 22.9647887,46.6704225 C22.9647887,46.6704225 13.471831,44.4510798 9.9084507,40.6760563 Z"
                            id="Shape"
                            fill="url(#linearGradient-7)"
                            style="mix-blend-mode: multiply;"/>
                        <path
                            d="M36.8873239,18.8679812 C34.2450348,16.0009667 30.5473064,14.373366 26.6760563,14.373366 C22.8048062,14.373366 19.1070778,16.0009667 16.4647887,18.8679812 C14.6238534,20.817811 13.597039,23.4126827 13.5985915,26.1111737 C13.6179088,31.7310605 18.1089886,36.2820214 23.6549296,36.3015962 C28.5866811,36.2904836 32.7859523,32.6641519 33.5788808,27.7316477 C34.3718093,22.7991435 31.5254104,18.0097749 26.8521127,16.4131455 C30.1470477,16.4739669 33.2771207,17.8848032 35.528169,20.3237559 C40.4155012,25.6573542 40.4155012,33.9080918 35.528169,39.2416901 C32.4009359,42.6676952 28.0048846,44.6161564 23.3994262,44.6175111 C18.7939679,44.6188658 14.396801,42.6729911 11.2676056,39.2488263 C11.2676056,39.2488263 1.73239437,30.542723 6.05633803,17.8403756 C1.66901408,27.4384977 5.88732394,36.4371831 9.9084507,40.6760563 C13.3850141,44.4887987 18.2750501,46.6569087 23.3978873,46.6569087 C28.5207246,46.6569087 33.4107605,44.4887987 36.8873239,40.6760563 C42.5399011,34.5267994 42.5399011,24.9958297 36.8873239,18.8465728 L36.8873239,18.8679812 Z M31.6901408,26.0897653 C31.7768711,29.0600863 30.2626065,31.8431732 27.7375495,33.3542854 C25.2124924,34.8653976 22.0762399,34.8653976 19.5511829,33.3542854 C17.0261258,31.8431732 15.5118613,29.0600863 15.5985915,26.0897653 C15.5839012,23.9556524 16.3633934,21.8943061 17.7816901,20.3166197 C19.3592668,18.7831838 21.4618673,17.9288835 23.6478873,17.9331455 C28.0890309,17.9410116 31.6862655,21.5894013 31.6901408,26.0897653 Z"
                            id="Shape"
                            fill="#DA291C"/>
                        <path
                            d="M26.8521127,16.4131455 L26.6549296,16.4131455 C23.2930071,16.418091 20.0832531,17.833816 17.7887324,20.3237559 C19.3663091,18.79032 21.4689095,17.9360197 23.6549296,17.9402817 C28.0905779,17.9520619 31.6824014,21.5949664 31.6901408,26.0897653 C31.6938222,29.1973856 29.9530678,32.036632 27.2020682,33.4100076 C24.4510686,34.7833832 21.1687324,34.4518035 18.7394366,32.5551174 L17.7816901,34.389108 C21.0003214,36.7384333 25.2796243,36.9558904 28.7140494,34.9446468 C32.1484744,32.9334033 34.0990935,29.0676235 33.6973069,25.0687177 C33.2955203,21.0698119 30.6160748,17.681722 26.8521127,16.4131455 Z"
                            id="Shape"
                            fill="url(#linearGradient-8)"
                            opacity="0.6"
                            style="mix-blend-mode: multiply;"/>
                    </g>
                </g>
            </g>
        </svg>
        -->
    </div>
</template>
<script>
    import logo from '@/assets/img/hempel-yacht.png'
    export default {
        data() {
            return {
                logo
            }
        }
    }
</script>
